// Centralized legal & company configuration.
//
// NOTE (internal, do not surface publicly): All legal copy on the site
// referencing these values is draft content pending attorney review before
// public launch. Do not display any "draft" or "review" notice publicly.

import { emailAddresses } from "./email-config";
import { platformConfig } from "./platform-config";

export const legalConfig = {
  brandName: "Stylist Award",
  legalCompanyName: "Award LLC",
  legalEntityDetails: "Award LLC, a Wyoming limited liability company",
  supportEmail: emailAddresses.support,
  privacyEmail: emailAddresses.support,
  claimsEmail: emailAddresses.claims,
  votesEmail: emailAddresses.votes,
  nominationsEmail: emailAddresses.nominations,
  partnersEmail: emailAddresses.partners,
  pressEmail: emailAddresses.press,
  contactEmail: emailAddresses.contact,
  mailingAddress: "32 N. Gould Street\nCheyenne, Wyoming 82001",
  governingLaw: "State of Florida, United States",
  effectiveDate: "January 1, 2026",
  lastUpdated: "January 1, 2026",
  copyrightName: "Award LLC",
  websiteUrl: platformConfig.programUrl,
  platformUrl: platformConfig.platformUrl,
  programUrl: platformConfig.programUrl,
} as const;

export type LegalConfig = typeof legalConfig;
